import {
    Box,
    Divider,
    Heading,
    Text,
} from "@chakra-ui/react";
const Description = (props) => {
    return (
        < Box mt="70px" fontSize="14px" fontWeight="500" >
            <Heading textAlign="center" fontSize="26px" fontWeight="600">Description</Heading>
            <Divider my="30px" />
            {props.data ? <Text> {props.data} </Text> :
                <Text textAlign="center" width="100%">
                    No Description
                </Text>
            }
        </Box >


    );
}

export default Description;